import React from 'react'; //import React Component

export function AddBrand() {
    return (
        <div className='brandFilter'>

        </div>
    );
}